import { Flex, FlexProps } from "@chakra-ui/react";

import { ArrowLeftIcon } from "ui/Icons/Icons";
import { TitleM } from "ui/Typography/Typography";

export type NavigationHeaderProps = {
  title: string;
  subtitle?: React.ReactNode;
  showNavigationArrow?: boolean;
  onClickGoBack: () => void;
  rightElement?: React.ReactNode;
} & FlexProps;

const HEADER_HEIGHT = "56px";

export function NavigationHeader({
  title,
  subtitle = null,
  onClickGoBack,
  rightElement,
  showNavigationArrow = true,
  ...rest
}: NavigationHeaderProps) {
  return (
    <Flex
      h={HEADER_HEIGHT}
      minH={HEADER_HEIGHT}
      bg="white"
      px="s200"
      w="100%"
      alignItems="center"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      borderBottomColor="grey.250"
      {...rest}
    >
      {showNavigationArrow && (
        <ArrowLeftIcon
          data-testid="navigation-header-go-back-icon"
          cursor="pointer"
          boxSize="1.5rem"
          onClick={onClickGoBack}
        />
      )}
      <Flex flexDirection="column" flex={1} marginLeft="s100" gap="s25">
        <TitleM flex={1} noOfLines={1} textOverflow="ellipsis">
          {title}
        </TitleM>
        {subtitle}
      </Flex>
      {rightElement}
    </Flex>
  );
}
